export const ScaleTypes = {
  NA: "n/a",
  VerySmall: "very_small",
  Small: "small",
  Medium: "medium",
  Large: "large",
  VeryLarge: "very_large",
} as const;

export type ScaleType = (typeof ScaleTypes)[keyof typeof ScaleTypes];

export const scaleToNumber: Record<ScaleType, number> = {
  [ScaleTypes.NA]: 0,
  [ScaleTypes.VerySmall]: 1,
  [ScaleTypes.Small]: 2,
  [ScaleTypes.Medium]: 3,
  [ScaleTypes.Large]: 4,
  [ScaleTypes.VeryLarge]: 5,
};

export const numberToScale: Record<number, ScaleType> = {
  0: ScaleTypes.NA,
  1: ScaleTypes.VerySmall,
  2: ScaleTypes.Small,
  3: ScaleTypes.Medium,
  4: ScaleTypes.Large,
  5: ScaleTypes.VeryLarge,
};

export interface Tag {
  id: number;
  name: string;
  created_at?: string;
  updated_at?: string;
}

/**
 * Column configuration for table preferences.
 */
export interface Column<T> {
  property: string;
  label: string;
  width?: number;
  minWidth?: string | number;
  sortable?: boolean;
  formatter?: (row: T) => string | number | null;
  type?: string;
  enabled: boolean;
  filters?: { text: string; value: string | number }[];
  filterMethod?: (value: string | number, row: T) => boolean;
}

export type Model =
  | "organisation"
  | "area"
  | "branch"
  | "context"
  | "risk"
  | "cause"
  | "measure"
  | "consequence"
  | "generalReserveItem"
  | "scale"
  | "user";
